import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiStatusAndMessageResponse } from './survey.interface';
import {
  GetPSIDResponse,
  UploadPSIDResponse,
} from '../../interfaces/create-surveys.interface';
import { EnvironmentConfig } from '../../interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public createNewPriceBlock(srvId: number | undefined) {
    return this._http.get<ApiStatusAndMessageResponse>(
      `${this._baseUrl}/surveys/createBlock/${srvId}`
    );
  }

  uploadPSIDFile(payload: FormData) {
    return this._http.post<UploadPSIDResponse>(
      `${this._baseUrl}/inclexcl/PSIDFile`,
      payload
    );
  }

  clearUploadedPSIDbyPath(path: string) {
    return this._http.delete<{ apiStatus: string; msg: string }>(
      `${this._baseUrl}/inclexcl/file?path=${path}`
    );
  }

  getPSIDList(
    filePath?: string,
    hasRedirectUrl: boolean = false,
    surveyId?: number
  ) {
    return this._http.get<GetPSIDResponse>(
      `${
        this._baseUrl
      }/inclexcl/PSIDList?path=${filePath}&hasRedirectUrl=${hasRedirectUrl}&surveyId=${
        surveyId ? surveyId : ''
      }`
    );
  }
}
